import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import Printer from "@redotech/redo-web/arbiter-icon/printer.svg";
import { Flex } from "@redotech/redo-web/flex";
import { useMemo } from "react";

export function ManualLabelPackingSlipButtons({
  manualLabelData,
}: {
  manualLabelData?: {
    shipments?: Array<{
      address: any;
      returnItemIds: string[];
      packingSlipUrl?: string | null;
    }> | null;
  } | null;
}) {
  function openUrl(url: string) {
    window.open(url, "_blank");
  }

  const packingSlipButtons = useMemo(() => {
    if (!manualLabelData?.shipments?.length) {
      return null;
    }

    const shipmentsWithPackingSlips = manualLabelData.shipments.filter(
      (shipment) => shipment.packingSlipUrl,
    );

    if (!shipmentsWithPackingSlips.length) {
      return null;
    }

    return shipmentsWithPackingSlips.map((shipment, index) => (
      <RedoButton
        hierarchy="secondary"
        IconLeading={Printer}
        key={index}
        onClick={() => openUrl(shipment.packingSlipUrl!)}
        text={
          shipmentsWithPackingSlips.length > 1
            ? `Print packing slip ${index + 1}`
            : "Print packing slip"
        }
      />
    ));
  }, [manualLabelData?.shipments]);

  if (!packingSlipButtons) {
    return null;
  }

  return (
    <Flex flexDirection="row" gap="sm" grow={1} pt="xs">
      {packingSlipButtons}
    </Flex>
  );
}
